import { AfterContentInit, AfterViewInit, Injectable, OnDestroy, OnInit } from "@angular/core";
import { Subject, BehaviorSubject, fromEvent } from "rxjs";
import { takeUntil, debounceTime } from "rxjs/operators";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AppConfigService } from './app-config.service';
import { environment } from "src/environments/environment";

// Menu
export interface Menu {
  headTitle1?: string;
  headTitle2?: string;
  path?: string;
  title?: string | any;
  icon?: string;
  type?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  bookmark?: boolean;
  children?: Menu[];
}

@Injectable({
  providedIn: "root",
})
export class NavService{
  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(window.innerWidth);

  // Search Box
  public search: boolean = false;

  // Language
  public language: boolean = false;

  // Mega Menu
  public megaMenu: boolean = false;
  public levelMenu: boolean = false;
  public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

  // Collapse Sidebar
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

  // For Horizontal Layout Mobile
  public horizontal: boolean = window.innerWidth < 991 ? false : true;

  // Full screen
  public fullScreen: boolean = false;

  //app-config
  baseUrl = environment.basicUrl
  isYamama = this.appConfigService?.isYamama();
  isAjial = this.appConfigService?.isAjial();

  constructor(private router: Router, public translate: TranslateService, private appConfigService: AppConfigService) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, "resize")
      .pipe(debounceTime(1000), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 991) {
          this.collapseSidebar = true;
          this.megaMenu = false;
          this.levelMenu = false;
        }
        if (evt.target.innerWidth < 1199) {
          this.megaMenuColapse = true;
        }
      });
    if (window.innerWidth < 991) {
      // Detect Route change sidebar close
      this.router.events.subscribe((event) => {
        this.collapseSidebar = true;
        this.megaMenu = false;
        this.levelMenu = false;
      });
    }
  }

  ngOnDestroy() {
    // this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  MENUITEMS: Menu[] = [
    {
      title: 'Dashboard',
      icon: "home",
      type: "sub",
      badgeType: "light-primary",
      badgeValue: "1",
      active: true,
      children: [
        { path: "/dashboard/default", title: "Home", type: "link" },
      ],
    },
    {
      title: 'Academic Subjects',
      icon: "sample-page",
      type: "sub",
      badgeType: "light-primary",
      badgeValue: "5",
      active: true,
      children: [
        { path: "/academic-subjects/arabic", title: "AcademicSubjectsModule.Arabic", type: "link", badgeValue: "1", },
        { path: "/academic-subjects/english", title: "AcademicSubjectsModule.English", type: "link" },
        { path: "/academic-subjects/math", title: "AcademicSubjectsModule.Math", type: "link" },
        { path: "/academic-subjects/science", title: "AcademicSubjectsModule.Science", type: "link" },
        { path: "/academic-subjects/geographic", title: "AcademicSubjectsModule.Geographic", type: "link" },
      ],
    },
    {
      title: 'Behavior',
      icon: "social",
      type: "sub",
      badgeType: "light-primary",
      badgeValue: "",
      active: false,
      children: [
      ],
    },
    {
      title: 'Attendance',
      icon: "calender",
      type: "sub",
      badgeType: "light-primary",
      badgeValue: "",
      active: false,
      children: [
      ],
    },
    {
      title: 'Medical History',
      icon: "ui-kits",
      type: "sub",
      badgeType: "light-primary",
      badgeValue: "",
      active: false,
      children: [
      ],
    },
    {
      title: 'Chat',
      icon: "chat",
      type: "link",
      badgeType: "light-primary",
      active: false,
      path: '/chat',
    },
    {
      title: 'Nase7 AI',
      icon: "starter-kit",
      type: "link",
      badgeType: "light-primary",
      active: false,
      path: '/ai-teacher',
    },
  ];

  // Array
  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
}
